import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';

// OLD THEME (commented out - using Berry theme now)
// import { createTheme, ThemeProvider } from '@mui/material';
// import theme from './Utils/theme';

// NEW BERRY THEME
import { ConfigProvider } from './themes/context/ConfigContext';
import ThemeCustomization from './themes';
import config from './config';
// try {
//   const time = parseInt(sessionStorage.getItem('expiresIn'))
//   if (new Date().getTime() > time)
//     sessionStorage.clear()
// }
// catch (ex) {
//   console.log('No Token')
// }

document.getElementById('root').classList.add('h-100')

ReactDOM.render(
  <HashRouter>
    {/* OLD THEME - commented out */}
    {/* <ThemeProvider theme={theme}> */}
    
    {/* NEW BERRY THEME - wrapped with ConfigProvider and ThemeCustomization */}
    <ConfigProvider>
      <ThemeCustomization>
        <App />
      </ThemeCustomization>
    </ConfigProvider>
    
    {/* </ThemeProvider> */}
  </HashRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
